import Image1 from "../../assets/certificate1.png";
import Image2 from "../../assets/certificate2.png";
import Image3 from "../../assets/certificate3.png";
import Image4 from "../../assets/certificate4.png";
import Image5 from "../../assets/certificate5.jpg";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "Certificate Course HTML/CSS",
    description:
      "in 2020 i use Progate website as my preference to learn a basic knowledge how to make website use HTML/CSS",
  },
  {
    id: 2,
    image: Image2,
    title: "Certificate Course JavaScript",
    description:
      "in 2020 after i'm done with HTML/CSS it takes 1 week before i went to learn JavaScript",
  },
  {
    id: 3,
    image: Image5,
    title: "Certificate of Appreciation",
    description:
      "in 2021 i try to develop android with kotlin languange, and i got appreciate from IDN for doing make Covid-19 App for charity to Palestine",
  },
  {
    id: 4,
    image: Image3,
    title: "Certificate Course Git",
    description:
      "in 2022 i realise that i must keep the working being manage, so ... i learn git to manage all project in github.",
  },
  {
    id: 5,
    image: Image4,
    title: "Certificate Bootcamp",
    description:
      "in 2023 im improve my skill that doing fullstack bootcamp in buildwithangga.",
  },
];
